var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"locale":"es-ES","dense":"","mobile-breakpoint":"0","item-class":"style","headers":_vm.headers,"items":_vm.lineas,"items-per-page":4,"group-by":"Proyecto","show-group-by":"","footer-props":{
      itemsPerPageOptions: [2,4,6], // -> Add this example        
      itemsPerPageText: 'Lineas por pág.',        
      pageText: '{0}-{1} de {2}'
  },"header-props":{
      sortByText: 'Ordenar por'
  }},on:{"click:row":_vm.editMode},scopedSlots:_vm._u([{key:"no-data",fn:function(){return [_vm._v(" Impute horas para ver aquí el resumen ")]},proxy:true},{key:"no-results",fn:function(){return [_vm._v(" Impute horas para ver aquí el resumen ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }